/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Flagged_ActionInputs */

const en_wb_flagged_action = /** @type {(inputs: Wb_Flagged_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagged for review ✓`)
};

const lv_wb_flagged_action = /** @type {(inputs: Wb_Flagged_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodots pārbaudei ✓`)
};

/**
* | output |
* | --- |
* | "Flagged for review ✓" |
*
* @param {Wb_Flagged_ActionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_flagged_action = /** @type {((inputs?: Wb_Flagged_ActionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Flagged_ActionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_flagged_action(inputs)
	return en_wb_flagged_action(inputs)
});